import { render, staticRenderFns } from "./VehicleAccess.vue?vue&type=template&id=dafbaf7e&scoped=true"
import script from "./VehicleAccess.vue?vue&type=script&lang=js"
export * from "./VehicleAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafbaf7e",
  null
  
)

export default component.exports